'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var REAGAN_MAJOR_VERSION = exports.REAGAN_MAJOR_VERSION = 7;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/Reagan/static-7.24/js/constants.js
// module id = 264
// module chunks = 0